export default function (slotId, slotType, slotFamily, outcome) {
    var slot = {
        id: slotId,
        type: slotType,
        family: slotFamily,
        outcomes: []
    };
    slot.condition = outcome.get('condition');
    slot.isHeader = outcome.get('isHeader');
    return slot;
}



// WEBPACK FOOTER //
// ./src/components/grid/factories/SlotFactory.js